import { hasClass } from '@common/Utils';
import { useMediaQuery } from '@hook/useMediaQuery';
import { useSetSearchParams } from '@hook/useSetSearchParams';
import { PaginationMobile } from './PaginationMobile';
import { PaginationPc } from './PaginationPc';

export interface IPagination {
    page: number;
    size: number;
    lastPage: number;
    total: number;
    limit: number;
}

const scrToTop = () => {
    const isPurple = hasClass(document.body, 'ncPurple');
    const conEl = document.getElementById('container');

    if (isPurple && conEl) {
        conEl.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
        const topPos = (conEl?.offsetTop || 0) + 200;
        window.scrollTo({ top: topPos, behavior: 'smooth' });
    }
};

export const Pagination = ({ dat }: { dat: IPagination | undefined }) => {
    if (!dat || dat.lastPage < 2) return null;
    const setParams = useSetSearchParams();
    const isSmallScreen = useMediaQuery('(max-width: 959px)');

    const pageGo = (pageNum: string, toTop: boolean = false) => {
        setParams({ page: pageNum });
        toTop && scrToTop();
    };

    return (
        <>
            {!isSmallScreen && <PaginationPc dat={dat} pageGo={pageGo} />}
            {isSmallScreen && <PaginationMobile dat={dat} pageGo={pageGo} />}
        </>
    );
};
